var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUaLogoOnlyGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 28,
    viewBox: "0 0 45 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9718 28H33.4886C30.9678 28 28.9237 25.956 28.9237 23.4351C28.9237 21.3895 30.2688 19.6592 32.1218 19.0783L28.8942 13.5783L24.0885 21.7498C20.5643 27.7639 12.7966 29.7909 6.77787 26.2619C0.818159 22.7687 -1.15443 15.0197 2.3807 8.987L6.31035 2.2631C7.58089 0.0854871 10.3767 -0.647634 12.5543 0.624455C14.7319 1.89654 15.465 4.69234 14.193 6.86841L10.2618 13.597C9.76628 14.4419 9.61872 15.4049 9.84394 16.312C10.0598 17.1896 10.6112 17.9242 11.3956 18.384C13.0715 19.3656 15.2336 18.8018 16.2168 17.1259L24.9646 2.25223C25.7847 0.857439 27.282 0.00161314 28.8989 0.00161314H28.9004C30.5189 0.00161314 32.0162 0.860545 32.8363 2.25689L43.9092 21.1254C44.7371 22.5373 44.7464 24.2847 43.9341 25.7043C43.1202 27.124 41.6089 28 39.9718 28Z",
    fill: "#D7DF23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUaLogoOnlyGreen);
export default __webpack_public_path__ + "static/media/ua-logo-only-green.78976beab92b3d988626e5fff1c00724.svg";
export { ForwardRef as ReactComponent };